var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormulateInput',{attrs:{"type":"toggle"},on:{"change":_vm.handleToggle},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}})
}
var staticRenderFns = []

export { render, staticRenderFns }